import { useEffect, useState } from 'react';
import { HOME } from '@shared/home';
import { fallbackWeather, fetchOpenMeteo } from '@shared/openMeteo';
import { api } from '@/lib/api';
import { hasWorkerApi } from '@/lib/hasWorkerApi';
import type { WeatherNow } from '@shared/types';

export function useWeather() {
  const [weather, setWeather] = useState<WeatherNow>(() => fallbackWeather());
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (hasWorkerApi()) {
        try {
          const res = await api.get<{ weather: WeatherNow }>('/weather');
          if (res.weather && !cancelled) {
            setWeather({
              ...res.weather,
              highC: res.weather.highC ?? res.weather.tempC,
              lowC: res.weather.lowC ?? res.weather.tempC,
            });
            return;
          }
        } catch {
          /* static host or Worker down — try Open-Meteo */
        }
      }
      try {
        const live = await fetchOpenMeteo(HOME.lat, HOME.lng);
        if (!cancelled) setWeather(live);
      } catch {
        if (!cancelled) {
          setWeather(fallbackWeather());
          setError(false);
        }
      }
    }

    load().finally(() => {
      if (!cancelled) setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return { weather, error, loading };
}
